module.exports = __webpack_public_path__ + "img/logo_ubras.a7e60fac.png";